import { render, staticRenderFns } from "./ProfileAgenda.view.vue?vue&type=template&id=b027c32e&"
import script from "./ProfileAgenda.view.vue?vue&type=script&lang=js&"
export * from "./ProfileAgenda.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports